module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-301.73ae2cf.woff2";